import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-brush-large.tsx
/**
* icon.24.brush.large
*
* Keywords: paintbrush, paint, art, drawing, tool, design, creative, canvas
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi4yMDcgMy43OTNBMSAxIDAgMCAwIDQuNSA0LjV2NGE0IDQgMCAwIDAgNS41MzQgMy42OTUgMi43OSAyLjc5IDAgMCAwIDEuMTIyIDIuODQ1bDYuNDc4IDQuNTczYTEuNDIgMS40MiAwIDAgMCAxLjk4LTEuOTc5bC00LjU3NC02LjQ3OGEyLjc5IDIuNzkgMCAwIDAtMi44NDUtMS4xMjJBNCA0IDAgMCAwIDguNSA0LjVoLS42NDJhMi4yOCAyLjI4IDAgMCAxLTEuNjExLS42Njd6TTUuNSA0LjU4VjQuNWwuMDQuMDRhMy4yOCAzLjI4IDAgMCAwIDIuMzE4Ljk2SDguNWEzIDMgMCAxIDEtMyAzem0xMi4yNiAxMy44OTgtNC40MTUtMy4xMTYgMi4wMTctMi4wMTYgMy4xMTYgNC40MTQuMDg3LjEyNC4xNDUuMjA1LjA4Ni4xMjJhLjQyLjQyIDAgMCAxLS41ODUuNTg1bC0uMTIyLS4wODYtLjIwNS0uMTQ1em0tMi45ODQtNS45NjEtMi4yNiAyLjI2LS43ODMtLjU1NGExLjc4NyAxLjc4NyAwIDEgMSAyLjQ5LTIuNDl6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-4910
*/
const Icon24BrushLarge = memo(function Icon24BrushLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M6.207 3.793A1 1 0 0 0 4.5 4.5v4a4 4 0 0 0 5.534 3.695 2.79 2.79 0 0 0 1.122 2.845l6.478 4.573a1.42 1.42 0 0 0 1.98-1.979l-4.574-6.478a2.79 2.79 0 0 0-2.845-1.122A4 4 0 0 0 8.5 4.5h-.642a2.28 2.28 0 0 1-1.611-.667zM5.5 4.58V4.5l.04.04a3.28 3.28 0 0 0 2.318.96H8.5a3 3 0 1 1-3 3zm12.26 13.898-4.415-3.116 2.017-2.016 3.116 4.414.087.124.145.205.086.122a.42.42 0 0 1-.585.585l-.122-.086-.205-.145zm-2.984-5.961-2.26 2.26-.783-.554a1.787 1.787 0 1 1 2.49-2.49z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24BrushLarge };

//# sourceMappingURL=icon-24-brush-large.js.map